"use client";

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import { useBreakpoint } from "@/shared/hooks/use-breakpoint";

// 모바일 전용 Swiper
function MobileSwiper() {
  const photos = [
    { id: "1", url: "/images/home/bg_01.webp", alt: "bg_01" },
    { id: "2", url: "/images/home/bg_02.webp", alt: "bg_02" },
    { id: "3", url: "/images/home/bg_03.webp", alt: "bg_03" },
    { id: "4", url: "/images/home/bg_04.webp", alt: "bg_04" },
    { id: "5", url: "/images/home/bg_05.webp", alt: "bg_05" },
    { id: "6", url: "/images/home/bg_06.webp", alt: "bg_06" },
    { id: "7", url: "/images/home/bg_07.webp", alt: "bg_07" },
    { id: "8", url: "/images/home/bg_08.webp", alt: "bg_08" },
    { id: "9", url: "/images/home/bg_09.webp", alt: "bg_09" },
    { id: "10", url: "/images/home/bg_10.webp", alt: "bg_10" },
    { id: "11", url: "/images/home/bg_11.webp", alt: "bg_11" },
  ];

  return (
    <Swiper
      slidesPerView={"auto"}
      spaceBetween={11.1}
      loop={true}
      centeredSlides={true}
      allowTouchMove={false}
      autoplay={{
        delay: 1,
        disableOnInteraction: false,
      }}
      speed={6000}
      modules={[Autoplay]}
      className="h-[191px] w-full mask-[var(--carousel-mask)] [-webkit-mask:var(--carousel-mask)]"
    >
      {photos.map((photo) => (
        <SwiperSlide key={photo.id} className="max-w-[273px]">
          <img src={photo.url} alt={photo.alt} className="h-[191px] w-[273px] object-cover" />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

// PC 전용 Swiper
function DesktopSwiper() {
  const photos = [
    { id: "1", url: "/images/home/bg_01.webp", alt: "bg_01" },
    { id: "2", url: "/images/home/bg_02.webp", alt: "bg_02" },
    { id: "3", url: "/images/home/bg_03.webp", alt: "bg_03" },
    { id: "4", url: "/images/home/bg_04.webp", alt: "bg_04" },
    { id: "5", url: "/images/home/bg_05.webp", alt: "bg_05" },
    { id: "6", url: "/images/home/bg_06.webp", alt: "bg_06" },
    { id: "7", url: "/images/home/bg_07.webp", alt: "bg_07" },
    { id: "8", url: "/images/home/bg_08.webp", alt: "bg_08" },
    { id: "9", url: "/images/home/bg_09.webp", alt: "bg_09" },
    { id: "10", url: "/images/home/bg_10.webp", alt: "bg_10" },
    { id: "11", url: "/images/home/bg_11.webp", alt: "bg_11" },
  ];

  return (
    <Swiper
      slidesPerView={"auto"}
      spaceBetween={32}
      loop={true}
      centeredSlides={true}
      allowTouchMove={false}
      autoplay={{
        delay: 1,
        disableOnInteraction: false,
      }}
      speed={6000}
      modules={[Autoplay]}
      className="h-[552px] w-full mask-[var(--carousel-mask)] [-webkit-mask:var(--carousel-mask)]"
    >
      {photos.map((photo) => (
        <SwiperSlide key={photo.id} className="max-w-[502px]">
          <img src={photo.url} alt={photo.alt} className="h-[552px] w-[788px] object-cover" />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export function SwiperCurvedCarousel() {
  const { isMobile } = useBreakpoint();

  return (
    <div className="tb:top-0 absolute top-[61px] left-0 z-0 w-full">
      {/* 곡선 마스크가 적용된 섹션 */}
      <section className="relative w-screen overflow-hidden">
        {/* SwiperJS 캐러셀 */}
        {isMobile ? <MobileSwiper /> : <DesktopSwiper />}
      </section>
    </div>
  );
}
